import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect, useCallback } from 'react';
import kebabCase from 'lodash/kebabCase.js';
import { pickDataAttributes } from '../../../utils/pickDataAttributes.js';
import { getCardType } from '../utils/get-card-type.js';
import { formatClassName as _formatClassName } from '../../../utils/formatClassName.js';
import { getParentClasses } from '../utils/get-parent-classes.js';

var useCardEffects = function useCardEffects(props, cardRef) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'wide' : _props$type,
      title = props.title,
      _props$isTabbable = props.isTabbable,
      isTabbable = _props$isTabbable === void 0 ? false : _props$isTabbable,
      _props$mediaSize = props.mediaSize,
      mediaSize = _props$mediaSize === void 0 ? type === 'narrow' ? 'full' : 'large' : _props$mediaSize,
      isChildCard = props.isChildCard,
      parentWrapped = props.parentWrapped,
      isSortable = props.isSortable,
      className = props.className,
      _props$mediaPosition = props.mediaPosition,
      mediaPosition = _props$mediaPosition === void 0 ? 'left' : _props$mediaPosition,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'vertical' : _props$orientation,
      _props$resizeSelector = props.resizeSelector,
      resizeSelector = _props$resizeSelector === void 0 ? '.page-wrapper' : _props$resizeSelector,
      _props$styleConfig = props.styleConfig,
      styleConfig = _props$styleConfig === void 0 ? {
    background: 'white',
    border: 'all',
    corner: 'none',
    shadow: 'none'
  } : _props$styleConfig;

  var _ref = styleConfig || {},
      background = _ref.background,
      border = _ref.border,
      corner = _ref.corner,
      shadow = _ref.shadow;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      cardClasses = _useState2[0],
      setCardClasses = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      cardWidth = _useState4[0],
      setCardWidth = _useState4[1];

  var _useState5 = useState('presentation-card'),
      _useState6 = _slicedToArray(_useState5, 2),
      dataAtrName = _useState6[0],
      setDataAtrName = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      dataAttributes = _useState8[0],
      setDataAttributes = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      hasLabel = _useState10[0],
      setHasLabel = _useState10[1];

  var _useState11 = useState(),
      _useState12 = _slicedToArray(_useState11, 2),
      hasMedia = _useState12[0],
      setHasMedia = _useState12[1];

  var _useState13 = useState(),
      _useState14 = _slicedToArray(_useState13, 2),
      hasOnClick = _useState14[0],
      setHasOnClick = _useState14[1];

  var _useState15 = useState(),
      _useState16 = _slicedToArray(_useState15, 2),
      mediaContainerClasses = _useState16[0],
      setMediaContainerClasses = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      mediaRight = _useState18[0],
      setMediaRight = _useState18[1];

  var _useState19 = useState(0),
      _useState20 = _slicedToArray(_useState19, 2),
      tabIndex = _useState20[0],
      setTabIndex = _useState20[1];

  var _useState21 = useState(),
      _useState22 = _slicedToArray(_useState21, 2),
      width = _useState22[0],
      setWidth = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      showChildren = _useState24[0],
      setShowChildren = _useState24[1];

  var _useState25 = useState(),
      _useState26 = _slicedToArray(_useState25, 2),
      cardType = _useState26[0],
      setCardType = _useState26[1];

  var _useState27 = useState(),
      _useState28 = _slicedToArray(_useState27, 2),
      parentClasses = _useState28[0],
      setParentClasses = _useState28[1];

  var isNarrow = cardType === 'narrow' || cardWidth <= 741;
  var isNarrowHorizontal = isNarrow && orientation === 'horizontal';
  useEffect(function () {
    setDataAttributes(pickDataAttributes(props, dataAtrName));
  }, [props, dataAtrName]);
  useEffect(function () {
    setCardType(getCardType(width, type));
  }, [width, type]);
  useEffect(function () {
    if (title) {
      setDataAtrName("".concat(kebabCase(title), "-presentation-card"));
    }
  }, [title]);
  useEffect(function () {
    setTabIndex(isTabbable ? 0 : -1);
  }, [isTabbable]);
  useEffect(function () {
    setCardClasses(_formatClassName(["presentation-card", "presentation-card-".concat(cardType), background ? "card-background-".concat(background) : '', border ? "card-border-".concat(border) : '', corner ? "card-corner-".concat(corner) : '', shadow ? "card-shadow-".concat(shadow) : '', "card-media-".concat(mediaSize), {
      'child-card': isChildCard
    }, {
      'parent-wrapped': parentWrapped
    }, {
      'card-clickable': hasOnClick
    }, {
      'p-l-15': isSortable
    }, className]));
  }, [width, type, background, border, cardType, className, corner, hasOnClick, isChildCard, isSortable, mediaSize, parentWrapped, shadow]);
  var updateCardDimensions = useCallback(function () {
    var container = resizeSelector ? document.querySelector(resizeSelector) : null;
    var card = cardRef;
    setWidth(container ? container.clientWidth : window.innerWidth);

    if (card && card.current) {
      setCardWidth(card.current.getBoundingClientRect().width);
    }
  }, [resizeSelector, cardRef]);
  useEffect(function () {
    setParentClasses(getParentClasses({
      width: width,
      type: type,
      mediaSize: mediaSize,
      mediaPosition: mediaPosition,
      cardWidth: cardWidth
    }));
  }, [width, type, mediaSize, mediaPosition, cardWidth]);
  useEffect(function () {
    setMediaRight(mediaPosition === 'right');
  }, [mediaPosition]);
  useEffect(function () {
    updateCardDimensions();
    window.addEventListener('resize', updateCardDimensions);
    return function () {
      window.removeEventListener('resize', updateCardDimensions);
    };
  }, [updateCardDimensions]);
  useEffect(function () {
    updateCardDimensions(); // We need to update card dimentions every time cardWidth changes
  }, [cardWidth, updateCardDimensions]);
  useEffect(function () {
    setHasMedia(Boolean(props.mediaUrl || props.mediaContent));
  }, [props.mediaUrl, props.mediaContent]);
  useEffect(function () {
    setHasOnClick(Boolean(props.onClick));
  }, [props.onClick]);
  useEffect(function () {
    setHasLabel(Boolean(props.specialLabel));
  }, [props.specialLabel]);
  useEffect(function () {
    setMediaContainerClasses(_formatClassName(['card-media-container', "card-media-".concat(mediaSize), {
      'no-media': !hasMedia,
      'narrow-horizontal': isNarrowHorizontal
    }]));
  }, [mediaSize, hasMedia, isNarrowHorizontal]);

  var toggleChildren = function toggleChildren(e) {
    e.preventDefault();
    e.stopPropagation();
    setShowChildren(!showChildren);
  };

  return {
    cardEffects: {
      cardClasses: cardClasses,
      dataAttributes: dataAttributes,
      hasLabel: hasLabel,
      mediaContainerClasses: mediaContainerClasses,
      mediaRight: mediaRight,
      tabIndex: tabIndex,
      showChildren: showChildren,
      parentClasses: parentClasses,
      cardType: cardType,
      hasMedia: hasMedia,
      toggleChildren: toggleChildren,
      width: width,
      cardWidth: cardWidth,
      isNarrow: isNarrow,
      isNarrowHorizontal: isNarrowHorizontal,
      hasOnClick: hasOnClick
    }
  };
};

export { useCardEffects };